import { fetch } from '../../utils';
import Backend from '../../backend';

export const getWechatSignature = async () =>
  fetch(Backend.api('wechat/signature') + '?url=' + encodeURIComponent(window.location.href.split('#')[0]))
    .then(res => {
      return res.json();
    })

